import {React, useContext } from 'react';
import PropTypes from 'prop-types';

import { ConfigContext } from '../../context/context'

import {  BsQuestion,
          BsInstagram, 
          BsLinkedin, 
          BsFacebook, 
          BsTiktok, 
          BsHouse,
          BsArrowRight, 
          BsPerson, 
          BsSuitHeart, 
          BsDownload, 
          BsList, 
          BsEnvelope, 
          BsEnvelopeFill, 
          BsTelephone, 
          BsSend, 
          BsHourglassTop, 
          BsHourglassSplit, 
          BsInfoCircle,
          BsGeoAltFill,
          BsBoxArrowInRight,
          BsBoxArrowLeft,
          BsPrinter,
          BsEnvelopeAt,
          BsPhoneVibrate,
          BsBusFront,
          BsCarFrontFill,
          BsGlobe2,
          BsCopy,
          BsCheck2,
          BsFillTagFill,
          BsCalendarEventFill,
          BsEnvelopeAtFill,
          BsCardText,
          BsClockFill,
        } from "react-icons/bs";

export default function Icon({ icon, size, color }) {
  const config = useContext(ConfigContext);

  let iconColor = config.mainColor

  if (color) {
    iconColor = color;
  }

let icons = <BsQuestion />

  switch (icon) {
    case 'linkedin':
      icons = <BsLinkedin color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'tiktok':
      icons = <BsTiktok color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'facebook':
      icons = <BsFacebook color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'instagram':
      icons = <BsInstagram color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'house':
      icons = <BsHouse color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'arrowRight':
      icons = <BsArrowRight color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'person':
      icons = <BsPerson color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'heart':
      icons = <BsSuitHeart color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'download':
      icons = <BsDownload color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'list':
      icons = <BsList color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'email':
      icons = <BsEnvelope color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'emailFill':
      icons = <BsEnvelopeFill color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'phone':
      icons = <BsTelephone color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'send':
      icons = <BsSend color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'hourglassTop':
      icons = <BsHourglassTop color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'hourglassSplit':
      icons = <BsHourglassSplit color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'infoCircle':
      icons = <BsInfoCircle color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'geoPin':
      icons = <BsGeoAltFill color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'boxArrowInRight':
      icons = <BsBoxArrowInRight color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'boxArrowLeft':
      icons = <BsBoxArrowLeft color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'printer':
      icons = <BsPrinter color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'envelopeAt':
      icons = <BsEnvelopeAt color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'mobile':
      icons = <BsPhoneVibrate color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'bus':
      icons = <BsBusFront color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'car':
      icons = <BsCarFrontFill color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'web':
      icons = <BsGlobe2 color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'copy':
      icons = <BsCopy color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'check':
      icons = <BsCheck2 color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'tag':
      icons = <BsFillTagFill color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    default:
      icons = <BsArrowRight color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'calender':
      icons = <BsCalendarEventFill color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'emailAt':
      icons = <BsEnvelopeAtFill color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'form':
      icons = <BsCardText color={iconColor} size={size} aria-label={icon +" Icon"} />
      break;
    case 'clock':
      icons = <BsClockFill color={iconColor} size={size} aria-label={icon +" Icon"} />
    }
    

  return (
  	icons
  );
}


Icon.propTypes = {
    size: PropTypes.string,
    icon: PropTypes.oneOf(['linkedin', 'tiktok', 'facebook', 'instagram', 'house', 'arrowRight', 'person', 'heart', 'download', 'list', 'email', 'phone', 'send', 'hourglassTop', 'hourglassSplit', 'emailFill', 'infoCircle', 'geoPin', 'boxArrowInRight', 'boxArrowLeft', 'printer', 'envelopeAt', 'mobile', 'bus', 'car', 'web', 'tag', 'calender', 'emailAt', 'form', 'clock', ]),
    /** Wenn nicht überschrieben, wird standardmässig 'mainColor' aus der Config verwendet. */
    color: PropTypes.string,  
}